import React from "react";
import Gallery from "@/components/Gallery";

export default function GalleryPage() {
  return (
    <main className="pt-24 sm:pt-28">
      <Gallery />
    </main>
  );
}
